import { GET_LEADLIST } from "../../Actions/ActionConstants";

function leadListReducer(state=null,action){
    switch (action.type) {
        case GET_LEADLIST:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default leadListReducer